import React from 'react'

import Quotes from 'app/components/SVGS/Quotes'

import './styles.scss'
const bc = 'activity-quote'

const ActivityQuote = ({ proQuote, proQuoteAuthor }) => (
  <div className={bc}>
    <span className={`${bc}__bracket`}>
      <Quotes />
    </span>
    <p className={`${bc}__text ${bc}__text-pos`}>{proQuote}</p>
    <div className={`${bc}__author`}>- {proQuoteAuthor}</div>
  </div>
)

export default ActivityQuote
